<template>
<div>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-body no-padding">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Declare Holiday</h3>
                  <span class="float-right"
                    ><button
                      type="button"
                      class="btn btn-success"
                      @click="newModal"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'active'"
                          class="badge bg-success"
                          >Active</span
                        >
                        <span v-else class="badge bg-danger">InActive</span>
                      </span>
                      <span v-if="props.column.field == 'id'">
                        <button
                          @click="editModal(props.row)"
                          class="btn btn-success btn-sm"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
          </div>
        </div>
        <!-- /.col -->
        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-body no-padding">
              <FullCalendar :options="calendarOptions" />
            </div>
          </div>
        </div>

        <!-- /.col -->
      </div>
      <!-- /.row -->
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editModal" class="modal-title">Add New Holiday</h4>
              <h4 v-show="editModal" class="modal-title">Update Holiday</h4>
            </div>
            <form
              @submit.prevent="editMode ? updateHoliday() : createHoliday()"
            >
              <div class="modal-body">
                <!-- right column -->
                <div class="col-md-12">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >Holiday Name <span class="red">*</span></label
                            >
                            <input
                              v-model="form.name"
                              type="text"
                              name="name"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('name') }"
                            />
                            <has-error :form="form" field="name"></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option v-if="!form.status" selected value="">
                                Select Status
                              </option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Holiday Date <span class="red">*</span></label
                            >
                            <input
                              v-model="form.date"
                              type="date"
                              name="date"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('date') }"
                            />
                            <has-error :form="form" field="date"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  SAVE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    </section>
    <!-- /.content -->
    

</div>
</template>

<script>
var _ = require('lodash')
// import { FullCalendar } from 'vue-full-calendar'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
// import { INITIAL_EVENTS, createEventId } from './event-utils'

export default {
  components: {
    // FullCalendar // make the <FullCalendar> tag available
    FullCalendar // make the <FullCalendar> tag available
  },
  data () {
    return {
      calendarOptions: {
        plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        initialView: 'dayGridMonth',
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
        dateClick: this.handleDateClick,
        currentEvents: [],
        events: [
          { title: 'event 1', date: '2019-04-01' },
          { title: 'event 2', date: '2019-04-02' }
        ]
      },
      editMode: false,
      form: new Form({
        id: '',
        name: '',
        date: '',
        status: false
      }),

      columns: [
        {
          label: 'HOLIDAY DATE',
          field: 'date'
        },

        {
          label: 'HOLIDAY NAME',
          field: 'name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        },

        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      columns1: [
        {
          label: 'DATE',
          field: 'date'
        }
      ],

      rows: [],
      rows1: [],

      events: []
    }
  },
  methods: {

    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar
      calendarApi.unselect() // clear date selection
      if (title) {
        calendarApi.addEvent({
          id: createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },
    handleEventClick (clickInfo) {
      if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
        clickInfo.event.remove()
      }
    },
    handleEvents (events) {
      this.currentEvents = events
    },

    handleDateClick: function (arg) {
      alert('date click! ' + arg.dateStr)
    },
    newModal () {
      this.form.reset()
      this.editMode = false
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    createHoliday () {
      this.$axios
        .post('holiday', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Holiday Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateHoliday () {
      this.$axios
        .put('holiday/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Holiday Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      this.$axios
        .get('holiday', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.rows = data.data.data
          // console.log(this.rows)
          // var evnt = {'title':'event3', 'date':'2020-10-07', 'allDay':true}  //'start':'2020-10-07T12:30:00',
          _.forEach(this.rows, function (value) {
            this.calendarOptions.events.push({ title: value.name, date: value.date, allDay: true })
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            console.log(error.response)
            // this.form.errors.errors = error.response.data.error
          }// .bind(this)
        )
    },
    loadSunday () {
      this.$axios
        .get('leavetype/sunday', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows1 = data
          _.forEach(this.rows1, function (value) {
            const dateString = value.replace('Sunday ', '')
            const changedDate = dateString.replace(/(..)\/(..)\/(....) (..):(..)/, '$3-$2-$1 $4:$5')
            var date = new Date(changedDate)

            var dd = date.getFullYear() + '-' + ('0' + parseInt(date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate())).slice(-2)

            this.calendarOptions.events.push({ title: 'Sunday', date: dd, allDay: true })
          }.bind(this))
        })
        .catch(
          function (error) {
            alert('byee')
            Toast.fire({icon: 'error', title: 'Please Try Again'})
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  created () {
    this.loadData()
    this.loadSunday()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>
<style lang='css'>
b { /* used for event dates/times */
  margin-right: 3px;
}
.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}
.demo-app-sidebar {
  width: 300px;
  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}
.demo-app-sidebar-section {
  padding: 2em;
}
.demo-app-main {
  flex-grow: 1;
  padding: 3em;
}
.fc { /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// HolidayMaster.vue?f5138aea